import { useContext } from "react";
import { FuelAnalysisContext } from "../context";

export const useFuelAnalysis = () => useContext(FuelAnalysisContext);
